/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
// Extends from
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import { action } from '@ember/object';

export default class GradeSchedulesController extends Controller {
  // Services
  @service
  store;

  @service
  toaster;

  // Deletion attributes
  @tracked
  deleteDialogOpen = false;

  @tracked
  deleteErrorMessage = '';

  @tracked
  deleteInProgress = false;

  @tracked
  entityToDelete = null;

  @tracked
  associatedAssessments = null;

  @tracked
  associatedModules = null;

  @tracked
  deleteWarningDialogOpen = false;

  @tracked
  dialogOpen;

  @tracked
  selectedTab;

  @action
  setSelectedTab(value) {
    this.selectedTab = value;
  }

  @tracked
  editingSchedule;

  @action
  editSchedule(schedule) {
    this.editingSchedule = schedule;
    this.dialogOpen = true;
  }

  @action
  delete(schedule) {
    // Find any modules or assessments that have this grade schedule
    // We need to warn them be
    let promises = [];
    promises.push(
      this.store.query('assessments/assessment', {
        gradeScheduleId: schedule.id,
      }),
    );
    promises.push(
      this.store.query('assessments/module', {
        gradeScheduleId: schedule.id,
      }),
    );
    return Promise.all(promises)
      .then((results) => {
        this.associatedAssessments = results[0];
        this.associatedModules = results[1];
        if (
          !isEmpty(this.associatedAssessments) ||
          !isEmpty(this.associatedModules)
        ) {
          // We need to warn the user about dependencies
          this.deleteWarningDialogOpen = true;
          this.entityToDelete = schedule;
        } else {
          this.openDeleteDialog(schedule);
        }
      })
      .catch((err) => (this.deleteErrorMessage = err));
  }

  @action
  closeWarningDeleteDialog() {
    this.deleteWarningDialogOpen = false;
    this.associatedAssessments = null;
    this.associatedModules = null;
  }

  @action
  continueDeleting() {
    this.closeWarningDeleteDialog();
    this.openDeleteDialog(this.entityToDelete);
  }

  @action
  openDeleteDialog(schedule) {
    this.deleteDialogOpen = true;
    this.entityToDelete = schedule;
  }

  @action
  confirmDelete(confirmed) {
    if (!confirmed) {
      // reset the deletion values
      this.deleteDialogOpen = false;
      this.entityToDelete = null;
      this.deleteErrorMessage = '';

      // we don't want to delete anything 👋
      return;
    }

    return new Promise((resolve, reject) => {
      // Deletion confirmed; actually delete the record.
      this.deleteInProgress = true;
      let entity = this.get('entityToDelete');
      // Delete record (locally + pushed to server).
      return entity
        .destroyRecord()
        .then(resolve)
        .catch((err) => {
          // Remove 'deleted' flag so that entity can be interacted with again.
          entity.rollbackAttributes();
          reject(err);
        });
    })
      .then(() => {
        // Tidy up / close dialog.
        this.deleteDialogOpen = false;
        this.entityToDelete = null;
        this.deleteErrorMessage = '';
        this.toaster.success(`grade schedule deleted successfully.`);
      })
      .catch((err) => {
        if (!isEmpty(err)) {
          if (err.errors && err.errors.length > 0) {
            this.deleteErrorMessage = err.errors[0].detail;
            return;
          }

          if (err.message) {
            this.deleteErrorMessage = err.message;
            return;
          }
        }

        this.deleteErrorMessage =
          'An unknown error occurred. Please try again.';
      })
      .then(() => {
        this.deleteInProgress = false;
      });
  }
}
